<template>
  <div class="dial-table-container">
    <div class="fdmt-tables">
      <div class="smmt-table">
        <div class="table-container">
          <div class="column" v-for="(row, index) in dialInfo.metricsTable.metricbase" :key="`row-${index}`">
            <div class="data-container" v-for="(column, index2) in row.data" :key="`column-${index2}`">
              <div :class="['header', column.label]" v-if="index2 === 0">{{ column.label }}</div>
              <div class="data large-rows">{{ column.value }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="smmt-table" v-if="dialInfo.metricsTable.metricmodified[0].data.length > 0">
        <div class="table-container">
          <div class="column" v-for="(row, index) in dialInfo.metricsTable.metricmodified" :key="`row-${index}`">
            <div class="data-container" v-for="(column, index2) in row.data" :key="`column-${index2}`">
              <div class="header" v-if="index2 === 0">{{ column.label }}</div>
              <div class="data empty"></div>
              <div class="data">{{ column.value }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="smmt-table">
        <div class="table-container">
          <div
            class="column"
            v-for="(row, index) in dialInfo.metricsTable.metricmixmain.original"
            :key="`row-${index}`"
          >
            <div class="data-container" v-for="(column, index2) in row" :key="`column-${index2}`">
              <div class="header" v-if="column.ordinal === '1'">{{ column.label }}</div>
              <div class="data">{{ column.value }}</div>
              <div class="data">{{ dialInfo.metricsTable.metricmixmain.modified[index][index2].value }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="smmt-table">
        <div class="table-container">
          <div
            class="column"
            v-for="(row, index) in dialInfo.metricsTable.metricmixlast.original"
            :key="`row-${index}`"
          >
            <div class="data-container" v-for="(column, index2) in row" :key="`column-${index2}`">
              <div class="header" v-if="column.ordinal === '1'">{{ column.label }}</div>
              <div class="data">{{ column.value }}</div>
              <div class="data" v-if="dialInfo.metricsTable.metricmixlast.modified[index][index2]">
                {{ dialInfo.metricsTable.metricmixlast.modified[index][index2].value }}
              </div>
              <div class="data empty" v-if="!dialInfo.metricsTable.metricmixlast.modified[index][index2]"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FDMT',
  components: {},
  props: {
    dialInfo: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.dial-table-container {
  margin-top: 28px;
  display: flex;
  flex-direction: column;
  .smmt-table {
    display: flex;
    margin-right: 40px;
    flex-direction: column !important;
    .table-header {
      min-height: 30px;
    }
    .table-container {
      display: flex;
      .row {
        display: flex;
        flex-direction: column;
        .header {
          background-color: #898c8d;
          color: white;
          padding: 12px 0px;
          font-size: 14px;
          min-height: 18px;
          width: 78px;
          &.Metric {
            width: 100% !important;
          }
        }
        .data {
          color: #1d1d1b;
          font-size: 14px;
          padding: 10px 0px;
          text-align: center;
        }
        .data:nth-child(odd) {
          background: #f9f9f9;
        }
        .total-row {
          background: white !important;
          font-weight: 600;
        }
      }
      .column {
        display: flex;
        flex-direction: column;
        .header {
          background-color: #898c8d;
          color: white;
          padding: 12px 0px;
          font-size: 14px;
          min-height: 18px;
          width: 78px;
          &.Metric {
            width: 100% !important;
          }
        }
        .data {
          color: #1d1d1b;
          font-size: 14px;
          padding: 10px 0px;
          text-align: center;
          &.large-rows {
            height: 54px;
            align-items: center;
            display: flex;
          }
          &.empty {
            content: '';
            min-height: 17px;
          }
        }
        .data-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        .data-container:nth-child(odd) {
          background: #f9f9f9;
        }
        .total-row {
          background: white !important;
          font-weight: 600;
        }
      }
    }
  }
}
.modified-row {
  display: flex;
}
.modified-data {
  color: #1d1d1b;
  font-size: 14px;
  padding: 10px 0px;
  text-align: center;
  width: 78px;
}
.fdmt-tables {
  display: flex;
}
.header {
  text-align: center;
}
</style>
